module.exports = __webpack_public_path__ + "img/title.70e01ad2.jpeg";